import script from "./UHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./UHeader.vue?vue&type=script&setup=true&lang=js"

import "./UHeader.vue?vue&type=style&index=0&id=31a1fafc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a1fafc"]])

export default __exports__